import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FooterButtons } from '../../../shared/components/Modals/FooterButtons';
import classNames from 'classnames';

export function ConfirmationModal({
  isOpen,
  title = 'Discard Message?',
  modalSize = 'sm',
  modalClassName = '',
  contentClassName = '',
  onConfirm,
  onCancel,
}) {
  return (
    <Modal
      isOpen={isOpen}
      size={modalSize}
      className={classNames(
        'nested-modal confirmation-modal model-form centered',
        modalClassName,
      )}
    >
      <ModalHeader>
        <h3>{title}</h3>
      </ModalHeader>
      <ModalBody>
        <div className={classNames('confirmation-container', contentClassName)}>
          <p>Your message will not be sent or saved.</p>
          <p>Are you sure you want to discard it?</p>
        </div>

        <FooterButtons
          onClose={onConfirm}
          showSaveButton={true}
          onSave={onCancel}
          closeText="Close Without Sending"
          saveText="Keep Editing"
        />
      </ModalBody>
    </Modal>
  );
}
